import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import classes from '../../../pipeline.module.scss';
import Api from '../../../../../../../api/api';
import Table from '../../../../../../_common/Tables/Table';
import { Card } from '../../PipelineComponents';
import { formattedCount, formattedDate, formattedDays } from '../../../pipelineHelpers';

const tableHeader = [
  { name: 'Member', path: 'name' },
  { name: 'Medication', path: 'productName' },
  { name: 'First fill', path: 'firstFillDate' },
  { name: 'Supply before', path: 'firstDaysSupply' },
  { name: 'Converted', path: 'conversionDate' },
  { name: 'Supply after', path: 'conversionDaysSupply' },
];

const limit = 10;

const MailOrderMembersCard = ({ params }) => {
  const navigate = useNavigate();

  const firstLoad = useRef(true);

  const [membersData, setMembersData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getMailOrderConversions({ ...params, limit });

        setMembersData((data?.data || []).map((d) => ({
          ...d,
          id: d.PatientId,
          name: [d.firstName, d.lastName].filter(Boolean).join(' '),
          firstFillDate: formattedDate(d.firstFillDate),
          firstDaysSupply: formattedDays(d.firstDaysSupply),
          conversionDate: formattedDate(d.conversionDate),
          conversionDaysSupply: formattedDays(d.conversionDaysSupply),
        })));

        setTotal(data?.data?._meta?.total);

        loadingToggle(false);
        firstLoad.current = false;
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [params]);

  return (
    <Card
      title="Converted members - detail"
      caption={`Member-level conversions behind the funnel - ${formattedCount(total)} rows, first ${limit}`}
      loading={loading}
      firstLoad={firstLoad.current}
      isEmpty={!membersData.length}
    >
      <div className={classes.pipeline_table}>
        <Table
          header={tableHeader}
          data={membersData}
          className={classes.clickable_row}
          onClick={(patientId) => navigate(`/patients/${patientId}`)}
        />
      </div>
    </Card>
  );
};

MailOrderMembersCard.propTypes = {
  params: PropTypes.object.isRequired,
};

export default MailOrderMembersCard;
